import { type PriceObjectDto } from "@modules/common/priceObject/gateway/priceObjectApiDto"

export class PriceObjectEntity {
  value: number
  currency: string

  private constructor(value: number, currency: string) {
    this.value = value
    this.currency = currency
  }

  static fromDto(dto: PriceObjectDto) {
    return new PriceObjectEntity(dto.value, dto.currency)
  }

  static fromValue(value: number, currency: string) {
    return new PriceObjectEntity(value, currency)
  }

  static toDto(priceObject: PriceObjectEntity): PriceObjectDto {
    return {
      value: priceObject.value,
      currency: priceObject.currency,
    }
  }
}

export class PriceObjectDraftEntity {
  value: number | null
  currency: string | undefined

  private constructor(value: number | null, currency: string | undefined) {
    this.value = value
    this.currency = currency
  }

  static toDto(priceObject: PriceObjectDraftEntity): PriceObjectDto {
    return {
      value: priceObject.value ?? 0,
      currency: priceObject.currency ?? "EUR",
    }
  }
}
